import { TOAST_VARIANT as s } from "../toast-variants.js";
import { TYPE as i } from "vue-toastification";
import { DEFAULT_TOAST_TIMEOUTS as e } from "../../constants/default-toast-timeouts.js";
import { TOAST_CLASS_NAME as u } from "../../constants/toast-class-name.js";
import T from "../components/close-toast-button/close-toast-button.vue.js";
class g {
  toastPluginOptions;
  constructor(t) {
    this.toastPluginOptions = t;
  }
  /**
   * Takes the IToastPluginOptions and sets the values to vue toastifications Plugin options.
   *
   * @returns the PluginOptions for vue toastification to use on install.
   */
  configurePluginOptions() {
    return {
      ...this.toastPluginOptions,
      position: this.toastPluginOptions.position,
      container: this.toastPluginOptions.mountContainerId ? this.findMountingContainer(this.toastPluginOptions.mountContainerId) : void 0,
      pauseOnHover: !!this.toastPluginOptions.pauseOnHover,
      transition: "Vue-Toastification__fade",
      hideProgressBar: !0,
      closeOnClick: !1,
      draggable: !1,
      toastDefaults: this.toastPluginOptions.toastNotificationTimeout ? this.setToastTimeoutOptions(
        this.toastPluginOptions.toastNotificationTimeout
      ) : e,
      toastClassName: u,
      closeButton: T
    };
  }
  /**
   * Takes the record of IToastPluginOptions toastNotificationTimeout and converts the keys of Toast Variants to vue-toastifications key type and sets the given timeout value to each toast variant. Sets default values if nothing is provided. Returns it as a type that the toast plugin can use.
   *
   * @param toastTimeoutOptions the IToastPluginOptions toastNotificationTimeout values.
   *
   * @returns a record of the Type of toast and the toast options of timeout that is type for the Toastification plugin to use.
   */
  setToastTimeoutOptions(t) {
    return {
      ...e,
      ...this.updateToastTimeouts(t)
    };
  }
  /**
   * Takes the record of IToastPluginOptions toastNotificationTimeout sets the given timeout value to each toast variant.
   *
   * @param toastTimeoutOptions the IToastPluginOptions toastNotificationTimeout values.
   *
   * @returns a record of the Type of toast and timeout option that is type for the Toastification plugin to use.
   */
  updateToastTimeouts(t) {
    return Object.keys(t).reduce((o, n) => {
      const a = t[n], r = this.mapToastVariantToType(n);
      return o[r] = { timeout: a }, o;
    }, {});
  }
  /**
   * Maps our TOAST_VARIANT enum types to vue-toastifications toast TYPES enum.
   *
   * @param toastVariant the TOAST_VARIANT
   *
   * @returns the TYPE for that TOAST_VARIANT
   */
  mapToastVariantToType(t) {
    switch (t) {
      case s.POSITIVE:
        return i.SUCCESS;
      case s.INFORMATIVE:
        return i.INFO;
      case s.NEGATIVE:
        return i.WARNING;
      default:
        return i.DEFAULT;
    }
  }
  /**
   * Finds the container by ID, to mount the toast notifications to.
   *
   * @param containerId string id name of the container.
   *
   * @returns the element or undefined. If undefined will use toastifications default container.
   */
  findMountingContainer(t) {
    const o = document.querySelector(`#${t}`);
    if (o instanceof HTMLElement)
      return o;
  }
}
export {
  g as ToastPluginOptions
};
//# sourceMappingURL=toast-plugin-options.js.map
